export default "__VITE_ASSET__Egmb7SuB__"